var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FFFDE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2267_22104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 20.5H7C6.60218 20.5 6.22064 20.342 5.93934 20.0607C5.65804 19.7794 5.5 19.3978 5.5 19V7C5.5 6.60218 5.65804 6.22064 5.93934 5.93934C6.22064 5.65804 6.60218 5.5 7 5.5H13H15.5C16.6046 5.5 17.5 6.39543 17.5 7.5V11.5",
    stroke: "#FAE000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5H8.5",
    stroke: "#FAE000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.5H8.5",
    stroke: "#FAE000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.5H10H8.5",
    stroke: "#FAE000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.125,
    cy: 17.125,
    r: 3.375,
    stroke: "#FAE000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5184 19.1529C17.5184 19.1844 17.5061 19.2001 17.4816 19.2001H16.8516C16.8236 19.2001 16.8096 19.1844 16.8096 19.1529V18.7539C16.6696 18.7434 16.5314 18.7206 16.3949 18.6856C16.2584 18.6471 16.1394 18.5929 16.0379 18.5229C16.0064 18.5019 15.9906 18.4686 15.9906 18.4231V17.6776C15.9906 17.6601 15.9959 17.6479 16.0064 17.6409C16.0204 17.6339 16.0344 17.6339 16.0484 17.6409C16.2374 17.7809 16.4299 17.8824 16.6259 17.9454C16.8219 18.0049 16.9934 18.0346 17.1404 18.0346C17.2734 18.0346 17.3609 18.0206 17.4029 17.9926C17.4449 17.9611 17.4659 17.9209 17.4659 17.8719C17.4659 17.8159 17.4326 17.7651 17.3661 17.7196C17.3031 17.6706 17.1806 17.6076 16.9986 17.5306C16.8131 17.4536 16.6539 17.3784 16.5209 17.3049C16.3914 17.2314 16.2846 17.1526 16.2006 17.0686C16.1201 16.9846 16.0606 16.8936 16.0221 16.7956C15.9836 16.6976 15.9644 16.5839 15.9644 16.4544C15.9644 16.3459 15.9801 16.2426 16.0116 16.1446C16.0431 16.0431 16.0921 15.9504 16.1586 15.8664C16.2286 15.7824 16.3161 15.7089 16.4211 15.6459C16.5296 15.5829 16.6609 15.5356 16.8149 15.5041V15.1104C16.8149 15.0824 16.8271 15.0684 16.8516 15.0684H17.4869C17.5149 15.0684 17.5289 15.0824 17.5289 15.1104V15.4884C17.6584 15.4989 17.7826 15.5216 17.9016 15.5566C18.0241 15.5881 18.1134 15.6231 18.1694 15.6616C18.1904 15.6791 18.2009 15.7036 18.2009 15.7351V16.4386C18.2009 16.4596 18.1956 16.4719 18.1851 16.4754C18.1746 16.4789 18.1641 16.4771 18.1536 16.4701C18.0381 16.3896 17.8964 16.3196 17.7284 16.2601C17.5604 16.1971 17.3819 16.1656 17.1929 16.1656C17.0494 16.1656 16.9514 16.1814 16.8989 16.2129C16.8499 16.2444 16.8254 16.2916 16.8254 16.3546C16.8254 16.4106 16.8674 16.4666 16.9514 16.5226C17.0354 16.5751 17.1824 16.6451 17.3924 16.7326C17.5849 16.8131 17.7441 16.8919 17.8701 16.9689C17.9996 17.0459 18.1011 17.1264 18.1746 17.2104C18.2481 17.2944 18.2989 17.3854 18.3269 17.4834C18.3584 17.5779 18.3741 17.6811 18.3741 17.7931C18.3741 17.9646 18.3444 18.1064 18.2849 18.2184C18.2254 18.3304 18.1519 18.4231 18.0644 18.4966C17.9804 18.5666 17.8876 18.6191 17.7861 18.6541C17.6881 18.6856 17.5989 18.7084 17.5184 18.7224V19.1529Z",
    fill: "#FAE000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2267_22104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoice);
export default __webpack_public_path__ + "static/media/icon_invoice.b62bede7a08658b6f8050ebbcf0045b6.svg";
export { ForwardRef as ReactComponent };